// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isEngagementCampaignsRestoreCampaignRetargetingDataResult = objectOf({
  immediately_restored: arrayOf(string),
  pending_restore: arrayOf(string),
  not_eligible: arrayOf(string),
});
